var option_webview_default = {
  "option": "c858R",
  "user_choice": "_8yZBL",
  "check": "fKI3P",
  "image": "P89zc",
  "input": "X3iuR",
  "title": "PgbFi",
  "centered": "gDxNt",
  "with_result": "hbVBD",
  "list": "CWcOt",
  "with_image": "Cv1aa",
  "progress": "rFzUj",
  "progress_value": "NKpma",
  "label": "_4KtEF",
  "cta": "F2v5-",
  "adornment_icon": "PZBaR",
  "remove": "aTDWQ",
  "removeButton": "GYT-f",
  "removeButtonIcon": "llRaJ",
  "overlay": "r7bPh",
  "shown": "w03uq",
  "dark": "GNqjh",
  "spinner": "_8H0Up",
  "spin": "_8qAdG",
  "grid": "hXulb"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
